import { environment } from "src/environments/environment";
export const authUrls = {
  checkMobileNumber: `${environment.apiURL}/auth/check`,
  login: `${environment.apiURL}/auth/login`,
  register: `${environment.apiURL}/auth/register`,
  getCountryList: `${environment.apiURL}/SystemCodes/GetCountries`,
};
export const branchUrl = {
  getbranchList: `${environment.apiURL}/branches`,
};

export const homeUrls = {
  getSerivces: `${environment.apiURL}/services`,
  getEmployees: `${environment.apiURL}/employees`,
}